import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getAutomaticCouponSettingAction = createAsyncThunk(
    'coupon/getAutomaticCouponSettingAction',
    async (automaticCouponType, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ AUTOMATIC_COUPON_SETTINGS_PATH }/${ automaticCouponType }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAutomaticCouponSettingSlice = createSlice({
    name: 'getAutomaticCouponSettingSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateAutomaticCouponSetting() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getAutomaticCouponSettingAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAutomaticCouponSettingAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAutomaticCouponSettingAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateAutomaticCouponSetting } = getAutomaticCouponSettingSlice.actions;
export const getAutomaticCouponSettingState = (state) => state.coupon.getAutomaticCouponSetting;
export default getAutomaticCouponSettingSlice.reducer;
